import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

interface IGetAnonymousComplaintCategoryResponse {
  message: string;
  payload:
    {
      content:ITipOffsCategory[];
    }
}

export interface ITipOffsCategory {
  id: string;
  name: string;
  nameEn: string;
  nameFr: string;
  description: string;
  descriptionEn: string;
  descriptionFr: string;
  createdAt: string;
  updatedAt: string;
}

@Injectable({
  providedIn: 'root',
})
export class TipOffCategoriesService {
  constructor(private api: ApiService) {}

  getTipOffCategories(): Observable<IGetAnonymousComplaintCategoryResponse> {
    const params = new HttpParams().set('unpaged', 'true');

    return this.api.GET<IGetAnonymousComplaintCategoryResponse>(
      'tip-offs-categories',
      { params }
    );
  }
}
